
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'

import vuescroll from 'vuescroll'
import { mapState } from 'vuex'
export default {
name: 'clotheSize',
props: [],
components: {
XHeader,
Group,
Cell,
XInput,
'scroller': vuescroll
},
data () {
return {
title: this.$route.meta.title,
value: '',
isCheck: 0,
sex: [
{
name: 'girl',
value: '女生'
},
{
name: 'boy',
value: '男生'
}
],
sizeInfo: {
sex: '请选择',
height: {
name: '请选择',
value: Number
},
weight: {
name: '请选择',
value: Number
},
head: {
name: '请输入',
value: ''
}
},
rulerOps: {
scrollPanel: {
scrollingX: false,
initialScrollY: 250
},
bar: {
background: 'rgba(0, 107, 178, 1)',
size: '3px',
opacity: 0
}
},
weighOps: {
scrollPanel: {
scrollingY: false,
initialScrollX: 50
},
bar: {
background: 'rgba(0, 107, 178, 1)',
size: '3px',
opacity: 0
}
},
ruler: {
max: 220
},
weigh: {
max: 160
},
subSizeTable: [],
headSizeTable: []
}
},
computed: {
...mapState({
userInfo: state => state.userInfo
})
},
created () {},
mounted () {

let sizeTable = JSON.parse(sessionStorage.getItem('sizeTable'))

this.subSizeTable = sizeTable.clothes
if (this.userInfo.sex === 1) {
this.isCheck = 1
} else if (this.userInfo.sex === 2) {
this.isCheck = 0
}
this.headSizeTable = sizeTable.hat

this.sizeInfo.sex = this.sex[this.isCheck].value
},
updated () {},
destroyed () {},
watch: {},
methods: {
back () {
setTimeout(() => {
this.$router.back(-1)
}, 300)
},
finish () {
if (this.sizeInfo.head.value) {
this.sendReferenceSize()
this.back()
} else {
this.$vux.toast.text('请输入头围', 'middle')
}
},
/* ruler */
handleScrollRuler (vertical, horizontal, nativeEvent) {
let num = this.ruler.max - (vertical.scrollTop / 5)
this.sizeInfo.height.name = num.toFixed(2) + 'cm'
this.sizeInfo.height.value = num
},
/* Weigh */
handleScrollWeigh (vertical, horizontal, nativeEvent) {
let offsetLeft = (this.$refs.markingWeigh.offsetLeft - 24) / 5
let num = offsetLeft + horizontal.scrollLeft / 5
this.sizeInfo.weight.name = num.toFixed(2) + 'kg'
this.sizeInfo.weight.value = num
},
sendReferenceSize () {
let obj = {
coat: '',
pants: '',
hat: '',
shoes: '38'
}

let heightSize = {}
let weightSize = {}
if (this.sizeInfo.height.value < this.subSizeTable[0].minHeight) {
heightSize = this.subSizeTable[0]
} else if (this.sizeInfo.height.value >= this.subSizeTable[this.subSizeTable.length - 1].maxHeight) {
heightSize = this.subSizeTable[this.subSizeTable.length - 1]
} else {
this.subSizeTable.forEach((element, i) => {
if (this.sizeInfo.height.value >= element.minHeight && this.sizeInfo.height.value < element.maxHeight) {
heightSize = element
}
})
}
if (this.sizeInfo.weight.value < this.subSizeTable[0].minWeight) {
weightSize = this.subSizeTable[0]
} else if (this.sizeInfo.weight.value >= this.subSizeTable[this.subSizeTable.length - 1].maxWeight) {
weightSize = this.subSizeTable[this.subSizeTable.length - 1]
} else {
this.subSizeTable.forEach((element, i) => {
if (this.sizeInfo.weight.value >= element.minWeight && this.sizeInfo.weight.value < element.maxWeight) {
weightSize = element
}
})
}
if (heightSize.id >= weightSize.id) {
obj.coat = heightSize.size
} else {
obj.coat = weightSize.size
}
obj.pants = obj.coat

if (this.sizeInfo.head.value < this.headSizeTable[0].minHead) {
obj.hat = this.headSizeTable[0].size
} else if (this.sizeInfo.head.value >= this.headSizeTable[this.headSizeTable.length - 1].maxHead) {
obj.hat = this.headSizeTable[this.headSizeTable.length - 1].size
} else {
this.headSizeTable.forEach((element, i) => {
if (this.sizeInfo.head.value >= element.minHead && this.sizeInfo.head.value < element.maxHead) {
obj.hat = element.size
}
})
}

let shoesSize = Math.ceil((this.sizeInfo.height.value / 6.868) * 2 - 10)
obj.shoes = String(shoesSize)
sessionStorage.setItem('referenceSize', JSON.stringify(obj))
this.$parent.getReferenceSize()
}
}
}



// WEBPACK FOOTER //
// ./src/yingxin/tskjxy/views/items/clothes/clotheSize.vue